/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { NavigationItemLink } from "@/src/types/Navigation.ts";
import Typography from "@mui/material/Typography";
import { Link, useLocation } from "react-router";
import { useHeader } from "@/src/components/Header/HeaderProvider.tsx";
import { navItemLinkStyle } from "@/src/components/Header/NavItemLink/navItemLinkStyle.ts";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { mergeSx } from "@/src/utils/mergeSx.ts";

export default function NavItemLink({ label, to, active }: NavigationItemLink) {
  const { pathname } = useLocation();
  const theme = useTheme();
  const { setMobileNavActive } = useHeader();

  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isActive = pathname === to || active;

  return (
    <Typography
      component={Link}
      to={to}
      variant={isDesktop ? "button" : "h5"}
      sx={mergeSx(navItemLinkStyle.navItemLink, isActive && navItemLinkStyle.active)}
      onClick={() => setMobileNavActive?.(false)}
      aria-current={isActive ? "page" : undefined}
    >
      {label}
    </Typography>
  );
}
